import { DateTime } from 'luxon';
import { CohortMetadata } from 'schemas/metadata/cohorts.ts';
import HighlightedTable from 'components/HighlightedTable/HighlightedTable.tsx';
import { Button } from 'nhsuk-react-components';
import { useNavigate } from 'react-router-dom';

interface IReviewCohortsSectionProps {
  teamId: string;
  teamCohorts: CohortMetadata[];
  lowerCaseCohortFilter: string;
}

function ReviewCohortsSection({
  teamId,
  lowerCaseCohortFilter,
  teamCohorts,
}: IReviewCohortsSectionProps) {
  const navigate = useNavigate();

  const handleEditCohortsClick = () => {
    navigate(`/admin/${teamId}/team-cohorts/edit`);
  };

  return (
    <>
      <HighlightedTable aria-label="cohorts">
        <HighlightedTable.HeaderRow>
          <HighlightedTable.HeaderValue>
            <div style={{ fontWeight: 'bold' }}>Name</div>
          </HighlightedTable.HeaderValue>
          <HighlightedTable.HeaderValue>
            Data last received
          </HighlightedTable.HeaderValue>
          <HighlightedTable.HeaderValue>
            People in cohort
          </HighlightedTable.HeaderValue>
        </HighlightedTable.HeaderRow>
        {teamCohorts
          .filter((cohort) => cohort.CohortLabel.toLowerCase().includes(lowerCaseCohortFilter))
          .map((cohort) => (
            <HighlightedTable.Row key={cohort.CohortLabel}>
              <HighlightedTable.Value>
                {cohort.CohortLabel}
                {cohort.Status === 'provisional' && (
                  <span className="nhsuk-u-secondary-text-colour nhsuk-u-font-size-14 nhsuk-u-font-weight-normal">
                    &nbsp;(Provisional)
                  </span>
                )}
              </HighlightedTable.Value>
              <HighlightedTable.Value>
                <span className="nhsuk-u-secondary-text-colour">
                  {cohort.LastRefreshed
                    ? DateTime.fromFormat(
                      String(cohort.LastRefreshed).slice(0, 12),
                      'yyyyMMddHHmm',
                    ).toFormat('dd LLLL yyyy')
                    : 'N/A'}
                </span>
              </HighlightedTable.Value>
              <HighlightedTable.Value>
                <span
                  className="nhsuk-u-secondary-text-colour"
                  style={{ textAlign: 'right' }}
                >
                  {cohort.MemberCount ? cohort.MemberCount : 'N/A'}
                </span>
              </HighlightedTable.Value>
            </HighlightedTable.Row>
          ))}
      </HighlightedTable>
      <Button small secondary style={{ float: 'right' }} onClick={handleEditCohortsClick}>
        Edit chosen cohorts
      </Button>
      <span className="nhsuk-u-clear" />
    </>
  );
}
export default ReviewCohortsSection;
